<template>
	<b-table :id="`${modelName}-list`" :sort-by.sync="filter.sortBy" :sort-desc.sync="sortDesc" :items="serviceOrders"
		:fields="getColumnsWithAction()" thead-class="list" v-on="tableListeners" ref="table" :selectable="selectable"
		:select-mode="selectMode">
		<template #cell(actions)="{ item, ...row }">
			<slot name="actions" :model="item" v-bind="row"></slot>
		</template>

		<template v-for="name in tableSlots" v-slot:[name]="data">
			<slot :name="'table:' + name" v-bind="data" />
		</template>
	</b-table>
</template>

<script>
import { capitalize } from 'lodash';

export default {
	props: [
		'moduleName',
		'modelName',
		'alertFetchName',
		'columns',
		'filter',
		'fetch',
		'noAdd',
		'noEdit',
		'noFilter',
		'noActions',
		'search',
		'selectable',
		'selectMode',
		'serviceOrders'
	],
	data() {
		return {
			sortDesc: true,
		};
	},
	computed: {
		tableSlots() {
			return Object.keys(this.$scopedSlots)
				.filter(k => /^table:(.*)$/.test(k))
				.map(k => k.replace("table:", ""));
		},
		tableListeners() {
			return Object.entries(this.$listeners)
				.filter(([k]) => /^table:(.*)$/.test(k))
				.map(([k, v]) => [k.replace("table:", ""), v])
				.reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
		}
	},
	methods: {
		capitalize,
		getDefaultFilter() {
			return this.defaultFilter ? this.defaultFilter : {};
		},
		getColumnsWithAction() {
			if (this.noActions) return this.columns;
			return [
				...this.columns,
				{ key: 'actions', label: "Ações" },
			];
		},
	},
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/shared/BaseList.vue